import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function InstagramIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M2 22H22V2H2V22ZM18.0101 9.99662H14.0034V14.0034H10.0135V18.0101H6.00676V6.00676H18.0101V9.99662Z" />
        </SvgIcon>
    );
}

export default InstagramIcon;
